// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"742f354d","808":"f9f7a948"}[chunkId] + ".chunk.js";
};